import { Box, Icon, Text, useClassNames } from '@factorialco/deprecated-design-system'

import { formatDateRange } from 'modules/core/components/DateNavigator/dateFormatUtils'

import * as style from './index.vanilla.css'

type Props = {
  startDate: Date
  endDate: Date

  leftStepperDisabled?: boolean
  rightStepperDisabled?: boolean
  dateDisabled?: boolean
  longMonth?: boolean
  withRelativeDates?: boolean

  onLeftStepperClick?: () => void
  onRightStepperClick?: () => void
  onDateClick?: () => void
}

export const NavigatorChip = ({
  startDate,
  endDate,
  leftStepperDisabled,
  rightStepperDisabled,
  dateDisabled,
  longMonth,
  withRelativeDates = true,
  onLeftStepperClick,
  onRightStepperClick,
  onDateClick,
}: Props) => {
  const cx = useClassNames(style)
  const borderStyle = { width: 's1', style: 'solid', color: 'grey400' } as const

  const label = formatDateRange(startDate, endDate, longMonth, withRelativeDates)

  return (
    <Box flexDirection="row" minWidth="s240" height="s32">
      <Box
        className={cx('clickable', {
          disabled: leftStepperDisabled,
        })}
        width="s32"
        height="full"
        alignItems="center"
        justifyContent="center"
        border={{ all: borderStyle }}
        borderRadius={{ topLeft: 'abs008', bottomLeft: 'abs008' }}
        onClick={onLeftStepperClick}
      >
        <Icon.Small icon="chevron-left" color="grey600" />
      </Box>

      <Box
        className={cx('clickable', {
          disabled: dateDisabled,
        })}
        flexDirection="row"
        flexGrow
        paddingX="s8"
        alignItems="center"
        justifyContent="center"
        gap="s4"
        border={{ top: borderStyle, bottom: borderStyle }}
        onClick={onDateClick}
      >
        <Text.Normal color="grey1000" size="200">
          {label}
        </Text.Normal>
        <Icon.Small icon="chevron-down" color="grey600" />
      </Box>

      <Box
        className={cx('clickable', {
          disabled: rightStepperDisabled,
        })}
        width="s32"
        height="full"
        alignItems="center"
        justifyContent="center"
        border={{ all: borderStyle }}
        borderRadius={{ topRight: 'abs008', bottomRight: 'abs008' }}
        onClick={onRightStepperClick}
      >
        <Icon.Small icon="chevron-right" color="grey600" />
      </Box>
    </Box>
  )
}
